import 'rxjs/add/operator/finally';
import { Component, OnInit } from '@angular/core';
import { ResultsSearchService } from './results-search.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalLoadingComponent } from '../shared/modal-loading/modal-loading.component';
import { MatDialog } from '@angular/material/dialog';
import { setting } from '../../../setting';
import { RestService } from '../shared/rest.service';
import { AuthService } from '../pages/com.usblick.common/auth/auth.service';
import { UserService } from '../pages/com.usblick.common/auth/user.service';
import { AppService } from '../app.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  quote: string;
  isLoading: boolean;
  _payload: any;
  _results: any;
  _origin: string;
  _close: boolean;
  modal: boolean;

	public domain: string;
	public getClientsSettingAppBooking: any;
	public loadSetting : boolean;
  reloadCategories: boolean = true;


  constructor(
    private resultsSearch: ResultsSearchService,
    public spinnerService: NgxSpinnerService,
    private dialog: MatDialog,
    private restService: RestService,
    private authService: AuthService,
    private userService: UserService,
    private appService: AppService
  ) {
		this.domain = setting.c_domain;
		this.loadSetting = false;
    this.getClientsSettingAppBooking =  JSON.parse((localStorage.getItem(setting.name)));
  }

  ngOnInit() {
    this.isLoading = true;
    this._close = false;
    this.modal = false;
    window.scrollTo(0, 0);
    this.clear();

    // Primera visita real (localStorage todavío vacío): el constructor no
    // encontró nada que leer y getClientsSettingAppBooking quedó en null
    // para siempre — nada más lo vuelve a poblar. Sin esto, #home nunca se
    // pinta (su *ngIf depende de este valor) y la página queda en blanco.
    if (!this.getClientsSettingAppBooking) {
      this.appService.getClientsSettingAppBooking().subscribe({
        next: (response: any) => {
          if (response?.id) {
            this.getClientsSettingAppBooking = response;
            localStorage.setItem(setting.name, JSON.stringify(response));
          }
        },
        error: (error) => console.log('Error cargando clients setting: ', error)
      });
    }

    // Subscribe to reload categories signal from new file action
    this.restService.reloadSearchCategories$.subscribe((res: boolean) => {
      if (res) {
        this.triggerReloadCategories();
      }
    });
  }

  triggerReloadCategories(): void {
    this.reloadCategories = false;
    setTimeout(() => {
      this.reloadCategories = true;
    }, 0);
  }

  clear(){
    if(localStorage.getItem("others")){
      // console.log("se limpio others");
      localStorage.removeItem("others");
    }

   /* if(localStorage.getItem("paxList")){
      localStorage.removeItem("paxList");
    }*/

    if(localStorage.getItem("origin")){
      localStorage.removeItem("origin");
    }

    if(localStorage.getItem("results")){
      localStorage.removeItem("results");
    }

    if(localStorage.getItem("payload")){
      localStorage.removeItem("payload");
    }


    if(localStorage.getItem("payloadModal")){
      localStorage.removeItem("payloadModal");
    }



    if(localStorage.getItem("form")){
      localStorage.removeItem("form");
    }

    //localStorage.clear();
  }

  async _onPayload(payload: any) {
    console.log('Recibido payload: ', payload);
    this._payload = payload;

    // Búsqueda real disparada sin agente en sesión: es acá donde arranca la
    // sesión de guest B2C (no en home ni en el bootstrap), bajo la agencia
    // B2C del cliente de sistema. Si ya hay agente (real o guest), no hace nada.
    if (!this.userService._agentID) {
      await this.authService.createGuestSession(this.getClientsSettingAppBooking?.id);
    }

 //   localStorage.setItem('payload', JSON.stringify(payload));
    this.resultsSearch._setPayload(payload);
  }

  _onResults(results: any) {
  //  console.log('Recibido resultados: ', results);
    this._results = results;
 //   localStorage.setItem('results',JSON.stringify(results));
    this.resultsSearch._setResponse(results);
  }

  _onOrigin(origin: any) {
   // console.log('Recibido origen: ', origin);
    localStorage.setItem('origin',origin);
    this._origin = origin;
    this.resultsSearch._setOrigin(origin);
  }

  _onLoading(isLoading: boolean) {
   // console.log('Is Searching?: ' + isLoading);
   // console.log('Is this._payload?: ' + this._payload);
    this.isLoading = isLoading;
    // this.spinnerService.show();
    if  ((this.isLoading)) {
        this.openModalLoading(JSON.parse(localStorage.getItem('payload')));
    } else {
        this.dialog.closeAll();
    }
  }


 /// modal loading
  openModalLoading (data: any) {
    if (!this.dialog.getDialogById('loadModal')) {
      var dialogRef = this.dialog.open(ModalLoadingComponent, {
        width: '650px',
        id: "loadModal",
        data: data,
        disableClose: true
      });
  
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  _onClick() {
    if (this.modal) {
      this._close = true;
      this.modal = false;
    }
    else {
      this.modal = true;
    }
  }
  openModal($event) {
  /*  if ($event === 'true') {
      this.modal = true;
      this._close = false;
    } else {
      this.modal = false;
      this._close = false;
    }*/
  }
}
